import React from "react";
import { modelFactoryPages } from "./App.constants";
import { ApplicationWrapper } from "@innovyze/stylovyze";

import {
  INSIGHT_SUBSCRIPTIONS,
  PLANT_SUBSCRIPTIONS,
  Subscription,
} from '@innovyze/shared-utils';

const App = () => {
  const allowedSubscriptionsSet = new Set<Subscription>([
    ...Array.from(INSIGHT_SUBSCRIPTIONS),
    ...Array.from(PLANT_SUBSCRIPTIONS),
  ]);

  return (
    <ApplicationWrapper
      authenticate={true}
      injectTenantId={true}
      pages={modelFactoryPages}
      expiredSubscriptionsSet={allowedSubscriptionsSet}
      disableMapProvider={true}
    />
  );
};

export default App;